import { catchAsync } from './index.js';
import BaseAPI from './base.js';

class ManufacturerAPIService extends BaseAPI {
    constructor() {
        super({
            baseUrl: process.env.REACT_APP_API_URL,
            cacheKeyPattern: 'manufacturer-${method}-${url}',
            cacheExpiration: 10 * 60 * 1000, // 10 minutes
            debug: false
        });
    }

    getByLetterPage = catchAsync(async (letter, page) => {
        return this.request(`/manufacturers?letter=${letter}&page=${page}`);
    });

    search = catchAsync(async (keyword, page = 1) => {
        return this.request(
            `/search/manufacturers?keyword=${encodeURIComponent(keyword)}&page=${page}`
        );
    });

    getOne = catchAsync(async (uri) => {
        return this.request(`/manufacturers/${uri}`);
    });

    getTradeNamesForManufacturer = catchAsync(async (uri, page = 1) => {
        return this.request(`/manufacturers/${uri}/tradenames?page=${page}`);
    });

    getFeatures = catchAsync(async () => {
        return this.request(`/manufacturers/feature`);
    });

    /**
     * Test cache functionality
     * @returns {Promise<void>}
     */
    async testCache() {
        console.log('=== Starting Manufacturer Cache Test ===');
        
        // Test 1: First request (should hit API)
        console.log('\nTest 1: First request (should hit API)');
        const firstResult = await this.getOne('pfizer');
        console.log('First request result:', firstResult);

        // Test 2: Second request (should hit cache)
        console.log('\nTest 2: Second request (should hit cache)');
        const secondResult = await this.getOne('pfizer');
        console.log('Second request result:', secondResult);

        // Test 3: Different endpoint (should hit API)
        console.log('\nTest 3: Different endpoint (should hit API)');
        const searchResult = await this.search('pfizer');
        console.log('Search result:', searchResult);

        // Test 4: Cache statistics
        console.log('\nTest 4: Cache Statistics');
        const stats = this.getCacheStats();
        console.log('Cache stats:', stats);

        console.log('\n=== Manufacturer Cache Test Complete ===');
    }
}

const ManufacturerAPI = new ManufacturerAPIService();
export default ManufacturerAPI; 